import script from "./AdModal.vue?vue&type=script&setup=true&lang=js"
export * from "./AdModal.vue?vue&type=script&setup=true&lang=js"

import "./AdModal.vue?vue&type=style&index=0&id=57756416&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-57756416"]])

export default __exports__